/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import algolia from '../../../utils/algolia';
import React, { useState, useEffect } from 'react';
import ProgressCircle from '../../../components/ProgressCircle';
import { DebounceInput } from 'react-debounce-input';
import Product from '../../../components/Product/Product';

const getVerbs = (verbs, setVerbs, query, isMounted, facets = ["*"], facetFilters = []) =>
  algolia.search(query, {
    "getRankingInfo": true,
    "analytics": false,
    "enableABTest": false,
    "hitsPerPage": 12,
    "attributesToRetrieve": "*",
    "attributesToSnippet": "*:20",
    "snippetEllipsisText": "…",
    "responseFields": "*",
    "explain": "*",
    "page": 0,
    "facets": facets,
    "facetFilters": facetFilters
  }).then(res => {
    isMounted && setVerbs(res.hits)
  });

export default function Search() {
  const [loading, setLoading] = useState(false)
  const [searchWord, setSearchWord] = useState("")
  const [verbs, setVerbs] = useState([]);

  useEffect(() => {
    let isMounted = true;
    if (loading)
      return;
    if (searchWord.length > 3) {
      setLoading(true);
      getVerbs(verbs, setVerbs, searchWord, isMounted).then(() => {
        setLoading(false);
      });
    } else {
      setVerbs([]);
    }
    return () => {
      isMounted = false;
    }
  }, [searchWord]);

  return (
    <div className="container-sm p-4">
      <div className="input-group">
        <DebounceInput type="search"
          minLength={2}
          debounceTimeout={1000}
          className="form-control rounded"
          placeholder="Search"
          autoComplete="off"
          aria-label="Search"
          onChange={(text) => {
            setSearchWord(text.target.value)
          }} />
      </div>

      <div>
        {loading ?
          <div style={{ width: 'max-content', margin: 'auto', marginTop: 42 }}>
            <ProgressCircle />
          </div> :
          <div style={{ textAlign: 'center' }}>
            {verbs?.map((prod, index) => {
              return <Product data={prod} key={prod.pid} />
            })}
          </div>
        }
      </div>
    </div>
  );
}
